export enum NationalProgramStates {
  LIVE = 'LIVE',
  OPT_IN = 'OPT_IN',
  NA = 'NA',
}

export interface NationalProgram {
  id: string;
  bundleId: string;
  name: string;
  optInStartDate: string;
  freezeStartDate: string;
  freezeEndDate: string;
  nationalDefaultPrice: number;
  hagDefaultPrice: number;
  nationalPricePoints: number[];
  hagPricePoints: number[];
  optOutHidden: boolean;
  redeemableOnline: boolean;
  visibleOnline: boolean;
}

export interface NationalProgramGroup {
  groupId: string;
  nationalId: string;
  groupName: string;
  chosenPrice: number;
  chosenRedeemableOnline?: boolean | null;
  chosenVisibleOnline?: boolean | null;
}

export interface NationalProgramResponse {
  nationalProgram: NationalProgram | null;
  chosenPrices: NationalProgramGroup[] | null;
  state: NationalProgramStates;
}

export interface CreateNationalProgramRequestBody {
  bundleId: string | undefined;
  freezeName: string;
  optInStartDate: string;
  freezeStartDate: string;
  freezeEndDate: string;
  defaultPrice: number;
  pricePoints: number[];
  optOutHidden: boolean;
  redeemableOnline: boolean;
  visibleOnline: boolean;
  sustainPricingFlag: boolean;
}

export interface EditNationalProgramRequestBody {
  freezeName?: string;
  optInStartDate?: string;
  freezeStartDate?: string;
  freezeEndDate?: string;
  defaultPrice?: number;
  pricePoints?: number[];
  optOutHidden?: boolean;
  redeemableOnline?: boolean;
  visibleOnline?: boolean;
  sustainPricingFlag?: boolean;
}

interface PricePointMetrics {
  pricePoint: number;
  optInPercent: number;
}

interface ProgramMetrics {
  defaultPriceMetrics: PricePointMetrics;
  defaultPriceHagMetrics: PricePointMetrics;
  pricePointsMetrics: PricePointMetrics[];
  optOutPercent: number;
  optInProgress: number | undefined;
}

export interface OptInDetails {
  storeNo: string;
  orgId: string;
  dma: string;
  chosenPrice: number;
  fzCode: string;
  updatedBy: string;
  storeGroupName: string;
  optInDate: string;
}

export interface NationalProgramDetailsResponse {
  program: NationalProgram | null;
  programMetrics: ProgramMetrics;
  optInDetails: OptInDetails[];
}
